import React from 'react';
import classNames from 'classnames';
import { Tabs, TabType } from '../tabs';
import './integrated-tabs-content.scss';

type IntegratedTabsContentProps = {
  tabs: TabType[];
  activeTabIndex: number;
  setActiveTabIndex: (tabIndex: number) => void;
  children: React.ReactNode;
  padding?: string;
};

export const IntegratedTabsContent: React.FC<IntegratedTabsContentProps> = ({
  tabs,
  activeTabIndex,
  setActiveTabIndex,
  children,
  padding = '24px 24px 48px 24px',
}) => (
  <div className="integrated-tabs-content">
    {tabs.length > 1 ? (
      <Tabs
        tabList={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        tabsType="pills"
        isDivider={false}
        tabsListClassName="p-b-8 item-flex"
      />
    ) : null}
    <div
      className={classNames('integrated-content', {
        first: activeTabIndex === 0 && tabs.length > 1,
        last: activeTabIndex === tabs.length - 1 && tabs.length > 1,
      })}
      {...(padding ? { style: { padding } } : {})}
    >
      {children}
    </div>
  </div>
);
